import styled from 'styled-components';
import PropTypes from "prop-types";

const SubTitle = styled.div`
    font-size: 20px;
    font-weight: 500;

    margin: ${({space}) => 
        (space === 'Top' && '32px 0 0') ||
        (space === 'TopDown' && '32px 0 16px') || 
        (space === 'Down' && '0 0 16px') || 
        '0'
    };
`;

SubTitle.propTypes = {
    space: PropTypes.string
};

export default SubTitle;